export default [
  {
    path: '/center',
    name: 'center',
    component: () => import ('@/components/page/userCenter/center')
  }, {
    path: '/testjingjiang',
    name: 'testjingjiang',
    component: () => import ('@/components/page/userCenter/testjingjiang')
  },
  {
    path: '/loginRecord',
    name: 'loginRecord',
    component: () => import ('@/components/page/userCenter/loginRecord')
  },
  {
    path: '/centerInfo',
    name: 'centerInfo',
    component: () => import ('@/components/page/userCenter/centerInfo')
  },
 {
    path: '/tempPswd',
    name: 'tempPswd',
    component: () => import ('@/components/page/userCenter/tempPswd')
  },

  // 缓存管理
  {
    path: '/cacheMange',
    name: 'cacheMange',
    component: () => import ('@/components/page/userCenter/cacheMange')
  },

  // 消息推送
  {
    path: '/pushSend',
    name: 'pushSend',
    component: () => import ('@/components/page/userCenter/pushSend')
  },

  // 事件预警
  {
    path: '/eventWorm',
    name: 'eventWorm',
    component: () => import ('@/components/page/userCenter/event/eventWorm')
  },
  {
    path: '/eventInfo',
    name: 'eventInfo',
    component: () => import ('@/components/page/userCenter/event/eventInfo')
  },
  {
    path: '/addNewEvent',
    name: 'addNewEvent',
    component: () => import ('@/components/page/userCenter/event/addNewEvent')
  },

  // 版本信息
  {
    path: '/version',
    name: 'version',
    component: () => import ('@/components/page/userCenter/version/version')
  },
  {
    path: '/versionDetail',
    name: 'versionDetail',
    component: () => import ('@/components/page/userCenter/version/versionDetail')
  },

  /*
  *  设置
  * */
  {
    path: '/setting',
    name: 'setting',
    component: () => import ('@/components/page/userCenter/setting/setting')
  },
  {
    path: '/messagePush',
    name: 'messagePush',
    component: () => import ('@/components/page/userCenter/setting/messagePush')
  },
  // 设备信息
  {
    path: '/device',
    name: 'device',
    component: () => import ('@/components/page/userCenter/setting/device')
  },

  {
    path: '/account',
    name: 'account',
    component: () => import ('@/components/page/userCenter/setting/account')
  },
  {
    path: '/accountLocker',
    name: 'accountLocker',
    component: () => import ('@/components/page/userCenter/setting/accountLocker')
  },

  // 授权客户端
  {
    path: '/licManage',
    name: 'licManage',
    component: () => import ('@/components/page/userCenter/licManage')
  },
  // 房价优惠审批
  {
    path: '/dscManage',
    name: 'dscManage',
    component: () => import ('@/components/page/userCenter/dscManage')
  },


  // 自定义报表和第三方链接
  {
    path: '/system/selfReportSetting',
    name: 'system_selfReportSetting',
    component: () =>
      import ('@/components/page/userCenter/system/selfReportSetting')
  },
  {
    path: '/system/selfReportEdit',
    name: 'system_selfReportEdit',
    component: () =>
      import ('@/components/page/userCenter/system/selfReportEdit')
  },
  {
    path: '/system/thirdUrlSetting',
    name: 'system_thirdUrlSetting',
    component: () =>
      import ('@/components/page/userCenter/system/thirdUrlSetting')
  },
  {
    path: '/system/thirdUrlEdit',
    name: 'system_thirdUrlEdit',
    component: () =>
      import ('@/components/page/userCenter/system/thirdUrlEdit')
  },


  // TODO 这里的 reportView 和 reportViewR 看起来不该放在这里
  // 是自定义报表查看，等规划报表的时候再移出去

  // 我的报表
  {
    path: '/system/reportView',
    name: 'system_reportView',
    component: () =>
      import ('@/components/page/userCenter/system/reportView')
  },
  // 营日日报范围
  {
    path: '/system/reportViewR',
    name: 'system_reportViewR',
    component: () =>
      import ('@/components/page/userCenter/system/reportViewR')
  },
  // 营日报表范围
  {
    path: '/system/reportViewRange',
    name: 'system_reportViewRange',
    component: () =>
      import ('@/components/page/userCenter/system/reportViewRange')
  },

  // 系统参数设置
  {
    path: '/sysOption/sysOptionList',
    name: 'sysOptionList',
    component: () =>
      import ('@/components/page/userCenter/sysOption/sysOptionList')
  },
  {
    path: '/sysOption/sysOptionEdit',
    name: 'sysOptionEdit',
    component: () =>
      import ('@/components/page/userCenter/sysOption/sysOptionEdit')
  },
]



// WEBPACK FOOTER //
// ./src/router/modules/userCenter.js